export const USER_TOKEN = 'token';
export const LOGGED_IN = 'logged_in';


export const authenticateUser = (token) => {
    sessionStorage.setItem(LOGGED_IN, true);
    sessionStorage.setItem(USER_TOKEN, token)
    return true;
}

export const isAuthenticated = () => {
    let status  = sessionStorage.getItem(LOGGED_IN);
    if(status) {
        return true;
    }
    else{
        return false;
    }
}
export const logout = () => {
    sessionStorage.clear();
    return true;
}

export const getUserToken = () => {
    return sessionStorage.getItem(USER_TOKEN);
}

export const getImage = (id) => {
    let image = '';
    switch (id) {
        case 1:
            image = 'ait_fm.jpg';
            break;
        case 2:
            image = 'army_fm.jpg';
            break;
        case 8:
            image = 'aso_fm.jpg';
            break;
        case 9:
            image = 'brilla_fm.jpg';
            break;
        case 10:
            image = 'cool_fm.jpg';
            break;
        case 11:
            image = 'hot_fm.jpg';
            break;

        case 12:
            image = 'itv_fm.jpg';
            break;

        case 13:
            image = 'kapital_fm.jpg';
            break;

        case 16:
            image = 'kiss_fm.jpg';
            break;

        case 17:
            image = 'love_fm.jpg';
            break;
        
        case 18:
            image = 'mps_fm.jpg';
            break;

        case 19:
            image = 'nigeria_info_fm.jpg';
            break;

        case 20:
            image = 'raypower_fm.jpg';
            break;

        case 21:
            image = 'rhythm_fm.jpg';
            break;

        case 22:
            image = 'silverbird.jpg';
            break;

        case 23:
            image = 'vision_fm.jpg';
            break;

        case 24:
            image = 'wazobia_fm.jpg';
            break;

        case 25:
            image = 'we_fm.jpg';
            break;

        case 27:
            image = 'ait_fm.jpg';
            break;

        case 28:
            image = 'beat_fm.jpg';
            break;

        case 29:
            image = 'brilla_fm.jpg';
            break;

        case 30:
            image = 'city_fm.jpg';
            break;

        case 31:
            image = 'classic_fm.jpg';
            break;

        case 32:
            image = 'cool_fm.jpg';
            break;

        case 33:
            image = 'eko_fm.jpg';
            break;
        
        case 34:
            image = 'faaji_fm.jpg';
            break;

        case 35:
            image = 'galaxy_tv.jpg';
            break;

        case 36:
            image = 'insipration_fm.jpg';
            break;

        case 37:
            image = 'kennis_fm.jpg';
            break;

        case 38:
            image = 'kiss_fm.jpg';
            break;

        case 39:
            image = 'city_fm.jpg';
            break;

        case 40:
            image = 'naija_fm.jpg';
            break;

        case 41:
            image = 'tv_continental.jpg';
            break;

        case 42:
            image = 'max_fm.jpg';
            break;

        case 43:
            image = 'nigeria_info_fm.jpg';
            break;

        case 44:
            image = 'radio_one_fm.jpg';
            break;
    
        default:
            break;
    }

    return image;
}